import { render } from "./ModalCadCategoria.vue?vue&type=template&id=324db569&scoped=true"
import script from "./ModalCadCategoria.vue?vue&type=script&lang=js"
export * from "./ModalCadCategoria.vue?vue&type=script&lang=js"

import "./ModalCadCategoria.vue?vue&type=style&index=0&id=324db569&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324db569"]])

export default __exports__